import React,{useContext,useEffect,useState,useRef} from 'react'
import '../styling/Chats.css'
import notecontext from '../context/notes/notecontext'
import { Chatcontext } from '../context/notes/Chatcontext';
import { app, database, storage } from './firebaseConfig'
import { collection, addDoc,getDoc, getDocs, doc, updateDoc, deleteDoc ,onSnapshot,query,where,setDoc} from "firebase/firestore";
import { async } from '@firebase/util';

const Message = (props) => {
  const {msg}=props
  const [imagesrc, setimagesrc] = useState("https://www.pngall.com/wp-content/uploads/5/User-Profile-PNG-Image.png")
  const context = useContext(notecontext);
  const {data} = useContext(Chatcontext);
  const { user, getUserdetails } = context;
  const ref=useRef()

  useEffect(() => {
    getUserdetails();
    getImage();
    ref.current?.scrollIntoView({behavior:"smooth"})
}, [msg])

const getImage=async()=>{
  const collectionRef = collection(database, 'users')
  const emailQuery=query(collectionRef,where("email","==",user.email))
  const querySnapshot = await getDocs(emailQuery);
  querySnapshot.forEach(async(doc) => {
      setimagesrc(doc.data().imageURL)
    });
}
  return (
    <div ref={ref} className={`Message ${msg.senderid===user.email && "owner"}`}>
      <div className="messageinfo">
        <img id="navimg" src={msg.senderid===user.email ? imagesrc:data?.user?.imageURL} alt="" />
        <span>just now</span>
      </div>
      <div className="messagecontowner">
        {msg.text!=""&& <p className='textowner'>{msg.text}</p>}
        {msg.img && <img id="navimg1" src={msg.img} alt="" />}
      </div>
    </div>
  )
}

export default Message